import {post} from "./base";

export async function getAll(accessToken) {
  const result = await post("medici/GetMedici", {accessToken});
  return result.map((u) => ({
    ...u,
    // fullname: u.firstname + " " + u.lastname,
    // specializzazione: u.specializzazione,
    // address: u.address
  }));
  // "idMedico", "firstname", "lastname", "dateCreated", "idAgente", "email", "phone" ("agente" if admin)
}

export async function getByInput(accessToken, filters) {
  const result = await post("medici/GetMediciByInput", { jsonBody: {accessToken, filters}});
  return result.map((u) => ({
    ...u,
    // fullname: u.firstname + " " + u.lastname,
    // specializzazione: u.specializzazione,
    // address: u.address
  }));
  // "idMedico", "firstname", "lastname", "dateCreated", "idAgente", "email", "phone" ("agente" if admin)
}

export async function getProvince(accessToken) {
  const result = await post("medici/GetProvince", {accessToken} );
  return result.map((p) => ({
    ...p,
  }));
}

export async function getSpecializzazioni(accessToken) {
  const result = await post("medici/GetSpecializzazioni", {accessToken} );
  return result.map((p) => ({
    ...p,
  }));
}


export async function add(accessToken, data) {
  // data should contain 'idMedico', 'firstname', 'lastname', 'idAgente', 'email', 'phone'
  await post("medici/AddMedico", {jsonBody: {...data, accessToken}});
  console.log(`Medico ${data.idMedico} added`);
}

export async function remove(accessToken, idMedico) {
  await post("medici/DeleteMedico", {jsonBody: {accessToken, idMedico}});
  console.log(`Medico ${idMedico} deleted`);
}
